<div class="row" *ngIf="validating">
  <div class="col-md-12">
    <div class="spinner-bar"></div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/auth/auth-validate/auth-validate.component.html